import { render, staticRenderFns } from "./discountManagement.vue?vue&type=template&id=0d239c8a&scoped=true&"
import script from "./discountManagement.vue?vue&type=script&lang=ts&"
export * from "./discountManagement.vue?vue&type=script&lang=ts&"
import style0 from "./discountManagement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./discountManagement.vue?vue&type=style&index=1&id=0d239c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d239c8a",
  null
  
)

export default component.exports